import gql from 'graphql-tag';

export const STEMMER_SEARCH_TAG = gql`
  query stemmerSearchTag (
    $name: String
  ){
    StemmerSearchTag(
      name: $name
    ) {
      id,
      name
    }
  }
`;

export const GET_TAG = gql`
  query getTag (
    $id: ID,
    $name: String
  ) {
    Tag(
      id: $id,
      name: $name
    ) {
        id,
        name,
         __typename
       }
    }
`;

export const CREATE_TAG = gql`
  mutation createTag (
    $id: ID,
    $name: String
  ) {
    CreateTag(
      id: $id,
      name: $name
    ) {
        id,
        name
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation updateTag (
    $id: ID!,
    $name: String
  ) {
    UpdateTag(
      id: $id,
      name: $name
    ) {
        id,
        name
    }
  }
`;

export const DELETE_TAG = gql`
  mutation deleteTag (
    $id: ID!
  ) {
  DeleteTag(
    id: $id
  ) {
    id
  }
}
`;
